import { ChangeEventHandler, DragEventHandler } from "react";
import { Button } from "react-bootstrap";
import messages from "messages";
// components
import { ReactComponent as OutlineLockOn } from "assets/svg/outline-lock-on.svg";
import UploadZone from "components/upload-zone";
import ModalLayout, {
  ModalLayoutProps,
} from "components/modal/modal-layout/ModalLayout";
import UploadTasks from "../upload-tasks";
// styles
import styles from "./styles.module.scss";
// utils
import getClasses from "utils/getClasses";
// constants
import { UPLOAD_FILE_ACCEPT } from "../../../../../../constants";
// types
import type { DataTransferUploadTaskState } from "../../../../../../types";

type Props = ModalLayoutProps & {
  uploadTaskStates: DataTransferUploadTaskState[];
  onDrop: DragEventHandler<HTMLDivElement>;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onHide: () => void;
};
/**
 * renders the stateless UI for upload/import data
 */
const DataTransferUploaderUI = ({
  uploadTaskStates,
  onDrop,
  onChange,
  onHide,
  ...rest
}: Props) => {
  return (
    <ModalLayout
      backdrop={"static"}
      size={"lg"}
      centered
      onHide={onHide}
      disabled={uploadTaskStates.some((el) => el.percent !== 100)}
      {...rest}
      Header={messages.uploadFiles}
      headerClass={styles["data-transfer-uploader-ui__header"]}
      bodyClass={styles["data-transfer-uploader-ui__body"]}
      footerClass={styles["data-transfer-uploader-ui__footer"]}
      Footer={
        <>
          <Button
            // TODO: need UX for those two buttons
            className={styles["data-transfer-uploader-ui__action"]}
            variant="outline-primary"
            disabled={uploadTaskStates.some((el) => el.percent !== 100)}
            onClick={onHide}
          >
            {messages.cancel}
          </Button>
          <Button
            className={styles["data-transfer-uploader-ui__action"]}
            variant="primary"
            onClick={onHide}
            // TODO: might need to update logic here
            disabled={uploadTaskStates.some((el) => el.percent !== 100)}
          >
            {messages.upload}
          </Button>
        </>
      }
    >
      <div className={styles["data-transfer-uploader-ui__description"]}>
        <p>{messages.pleaseUploadYourPatient}</p>
        <p className={styles["data-transfer-uploader-ui__secure"]}>
          <OutlineLockOn
            className={styles["data-transfer-uploader-ui__lock"]}
          />
          {messages.yourDataIsSecure}
        </p>
      </div>
      {!uploadTaskStates.length ? (
        <UploadZone
          // TODO: should use the new drive name
          storageDrive={"patient-chart"}
          className={styles["data-transfer-uploader-ui__upload-zone"]}
          TextInitial={
            <>
              <p
                className={
                  styles["data-transfer-uploader-ui__upload-zone-text"]
                }
              >
                {messages.dragAndDropYourFiles}
              </p>
              <p
                className={getClasses(
                  styles["data-transfer-uploader-ui__upload-zone-text"],
                  styles[
                    "data-transfer-uploader-ui__upload-zone-text--highlight"
                  ],
                )}
              >
                {messages.or}
              </p>
            </>
          }
          accept={UPLOAD_FILE_ACCEPT}
          onChange={onChange}
          onDrop={onDrop}
        />
      ) : (
        <UploadTasks />
      )}
    </ModalLayout>
  );
};

export default DataTransferUploaderUI;
